import request from "@/utils/request";

/**
 * 获取游戏平台额度
 *
 * @description 获取游戏平台额度
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotUserAccount(playload = {}, config = {}) {
  return request({
    url: "/party/v2/game/queryLotUserAccount",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 一键归户
 *
 * @description 一键归户
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function regressionAccount(playload, config) {
  return request({
    url: "/party/v2/game/regressionAccount",
    method: "POST",
    data: playload,
    ...config,
    userId: true,
    noEncrypt: false
  });
}
/**
 * 获取棋牌游戏额度转换记录
 *
 * @description 获取棋牌游戏额度转换记录
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryTransformList(playload, config) {
  return request({
    url: "/party/v2/game/queryTransformList",
    method: "POST",
    data: playload,
    ...config,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 获取棋牌游戏投注记录
 *
 * @description 获取棋牌游戏投注记录
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryGameBettingList(playload, config) {
  return request({
    url: "/party/v2/game/queryGameBettingList",
    method: "POST",
    data: playload,
    ...config,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 额度转换
 *
 * @description 额度转换
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function transform(playload, config) {
  return request({
    url: "/party/v2/game/transform",
    method: "POST",
    data: playload,
    ...config,
    userId: true,
    noEncrypt: false
  });
}
/**
 * 登录棋牌游戏
 *
 * @description 登录棋牌游戏
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function loginGame(playload, config) {
  return request({
    url: "/party/v2/game/loginGame",
    method: "POST",
    data: playload,
    ...config,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 获取游戏列表（未加密）
 *
 * @description 获取游戏列表（未加密）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryGameList(playload, config) {
  return request({
    url: "/party/v2/game/queryGameList",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}
/**
 * 获取游戏平台
 *
 * @description 获取游戏平台
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryPlayForm(playload, config) {
  return request({
    url: "/party/v2/game/queryPlayForm",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}
/**
 * 获取平台下游戏
 */
export async function queryAllPlatformGames(data, config) {
  return request({
    url: "/party/v2/game/queryAllPlatformGames",
    method: "POST",
    data,
    ...config,
    noEncrypt: true
  });
}

/**
 * 获取第三方游戏大类
 *
 * @description 获取第三方游戏大类
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryGameTypes(playload, config) {
  return request({
    url: "/party/v2/game/queryGameTypes",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}

/**
 * 获取第三方游戏大类下的子类
 *
 * @description 获取第三方游戏大类下的子类
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryTypePlatforms(playload, config) {
  return request({
    url: "/party/v2/game/queryTypePlatforms",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}

/**
 * 获取第三方游戏二级分类下的游戏列表
 *
 * @description 获取第三方游戏二级分类下的游戏列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryPlatformGames(playload, config) {
  return request({
    url: "/party/v2/game/queryPlatformGames",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}
/**
 * 获取游戏模糊搜索全部游戏
 */
export async function queryGameSearchsingle(name) {
  return request({
    url: `/party/v2/game/queryGameSearch/single/${name}`,
    method: "POST",
    data: {},
    noEncrypt: true
  });
}

/**
 * 获取第三方游戏二级分类下的游戏列表
 *
 * @description 获取第三方游戏二级分类下的游戏列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryPlayIndex(playload, config) {
  return request({
    url: "/party/v2/game/queryPlayIndex",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}

/**
 * 196.3.0版首页和子页面信息接口
 *
 * @description 版首页和子页面信息接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryGameListTypes(playload, config) {
  return request({
    url: "/party/v2/game/queryGameListTypes",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}

/**
 * 197.3.0版搜索接口
 *
 * @description 197.3.0版搜索接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryGameSearch(playload, config) {
  return request({
    url: "/party/v2/game/queryGameSearch",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}
